import { ProductIcon } from './ProductIcon';
import { Spark } from './Spark';

/**
 * Chatbot product lockup — the standardised Magic.Lap sub-brand mark.
 *
 *   default  (sidebar):  [icon]  Chatbot
 *                                by Magic⚬Lap
 *
 *   hero     (login):    [icon]
 *                        Chatbot
 *                        by Magic⚬Lap
 *
 * Text is always English brand artwork regardless of active i18n language.
 * Layout flex adapts automatically to RTL via the document dir attribute.
 */

interface ProjectLockupProps {
  variant?: 'default' | 'hero';
  className?: string;
}

export function ProjectLockup({ variant = 'default', className = '' }: ProjectLockupProps) {
  const subline = (
    <span dir="ltr" className="font-sora font-medium text-[10px] leading-[1.2] text-secondary
                     inline-flex items-baseline gap-px select-none">
      by&nbsp;Magic<Spark variant="inline" />Lap
    </span>
  );

  if (variant === 'hero') {
    return (
      <div className={`flex flex-col items-center gap-3 ${className}`}>
        {/* Icon container — 56 × 56 */}
        <div
          className="w-14 h-14 rounded-brand-md flex items-center justify-center shrink-0"
          style={{
            background: 'var(--bg-canvas)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-sm), var(--shadow-inset)',
          }}
        >
          <ProductIcon size={32} />
        </div>

        <div className="text-center">
          <div dir="ltr" className="font-sora font-bold text-[20px] leading-[1.2] tracking-[-0.02em] text-primary select-none">
            Chatbot
          </div>
          <div dir="ltr" className="mt-0.5 font-sora font-medium text-[11px] leading-[1.2] text-secondary
                          flex items-baseline justify-center gap-px select-none">
            by&nbsp;Magic<Spark variant="inline" />Lap
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Icon container — 34 × 34 */}
      <div
        className="w-[34px] h-[34px] rounded-brand-sm bg-recessed border border-subtle
                   [box-shadow:var(--shadow-sm),var(--shadow-inset)]
                   flex items-center justify-center shrink-0"
      >
        <ProductIcon size={18} />
      </div>

      {/* Name + subline */}
      <div className="flex flex-col gap-px min-w-0">
        <span dir="ltr" className="font-sora font-bold text-[15px] leading-[1.2] tracking-[-0.015em] text-primary select-none">
          Chatbot
        </span>
        {subline}
      </div>
    </div>
  );
}
